import { render, staticRenderFns } from "./SocialInteraction.vue?vue&type=template&id=50df56e2"
import script from "./SocialInteraction.vue?vue&type=script&lang=js"
export * from "./SocialInteraction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports